import React from 'react';
import { ShieldCheck, Star, Lock } from 'lucide-react';
export function TrustFooter() {
  return <footer className="w-full bg-white border-t border-gray-200 py-3 sm:py-4 mt-8" data-id="element-253">
      <div className="max-w-4xl mx-auto px-4" data-id="element-254">
        <div className="flex items-center justify-center gap-4 sm:gap-10 text-gray-500" data-id="element-255">
          <div className="flex items-center gap-1.5" data-id="element-256">
            <div className="bg-blue-50 p-1.5 rounded-full" data-id="element-257">
              <ShieldCheck className="w-4 h-4 text-primary" data-id="element-258" />
            </div>
            <div className="flex flex-col" data-id="element-259">
              <span className="text-[10px] font-bold text-gray-700" data-id="element-260">BBB</span>
              <span className="text-[10px] font-semibold text-primary" data-id="element-261">A+</span>
            </div>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-262">
            <div className="bg-green-50 p-1.5 rounded-full" data-id="element-263">
              <Star className="w-4 h-4 text-green-500 fill-green-500" data-id="element-264" />
            </div>
            <div className="flex flex-col" data-id="element-265">
              <span className="text-[10px] font-bold text-gray-700" data-id="element-266">
                Trustpilot
              </span>
              <span className="text-[10px] font-semibold text-green-600" data-id="element-267">
                4.8/5.0
              </span>
            </div>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-268">
            <div className="bg-gray-100 p-1.5 rounded-full" data-id="element-269">
              <Lock className="w-4 h-4 text-gray-600" data-id="element-270" />
            </div>
            <div className="flex flex-col" data-id="element-271">
              <span className="text-[10px] font-bold text-gray-700" data-id="element-272">SSL</span>
              <span className="text-[10px]" data-id="element-273">256-bit</span>
            </div>
          </div>
        </div>
        <p className="hidden sm:block text-center text-[10px] text-gray-400 mt-2" data-id="element-274">
          Tu información está protegida con cifrado de 256 bits.
        </p>
      </div>
    </footer>;
}